// extracted by mini-css-extract-plugin
module.exports = {"legendWrapper":"Legend_legendWrapper__1VNzY","legendItem":"Legend_legendItem__2J2qV"};